import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 bg-[#FDF8F3] border-t border-[#3D3229]/5" data-id="element-30">
      <div className="container max-w-2xl mx-auto text-center" data-id="element-31">
        <FadeIn data-id="element-32">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#8B9E7E]/10 text-[#8B9E7E] mb-6" data-id="element-33">
            <ShieldCheck className="w-8 h-8" data-id="element-34" />
          </div>
          <h3 className="text-xl font-bold text-[#3D3229] mb-4" data-id="element-35">
            Garantía de satisfacción
          </h3>
          <p className="text-lg text-[#3D3229]/80 leading-relaxed" data-id="element-36">
            Tenés 7 días para probarlo. Si sentís que no es para vos, te
            devolvemos el dinero.
          </p>
        </FadeIn>
      </div>
    </section>;
}